export default {
    classNames: {
        agentWindowTTS: "alme--window--tts",
        agentWindowTTSClose: "alme--window--tts__close",
        agentWindowTTSControl: "alme--window--tts__control",
        almeResponseClassName: "alme--window--conversation--response--alme",
        almeResponseDisplayNameClassName: "alme--window--conversation--response--alme__message__displayname",
        almeResponseErrorClassName: 'alme--response--error',
        almeResponseErrorLink: 'error--response--link',
        almeResponseMessageClassName: "alme--window--conversation--response--alme__message",
        almeResponsePersonaIconClassName: "alme--window--conversation--response--alme__personaicon",
        almeResponseTextClassName: "alme--window--conversation--response--alme__message__text",
        bannerClassName: "alme--window--header--banner",
        calendarPane: "alme--window--feedback__calendar__widget__pane",
        calendarWidget: "calendar-widget",
        calendarWidgetBody: "calendar-widget-body",
        calendarWidgetBodyError: "calendar-widget-body-error",
        calendarWidgetCalendarWrapper: "calendar-widget-calendar-wrapper",
        calendarWidgetDayButton: "calendar-widget-day-button",
        calendarWidgetDayButtonSelected: "calendar-widget-day-button-selected",
        calendarWidgetDayEmpty: "calendar-widget-day-empty",
        calendarWidgetHeader: "calendar-widget-header",
        calendarWidgetHeaderNextMonth: "calendar-widget-header__next-month",
        calendarWidgetHeaderPrevMonth: "calendar-widget-header__prev-month",
        calendarWidgetHeaderTitle: "calendar-widget-header__title",
        calendarWidgetRow: "calendar-widget-row",
        calendarWidgetTable: "calendar-table",
        calendarWidgetTimeButton: "calendar-widget-time-button",
        calendarWidgetTimeButtonSelected: "calendar-widget-time-button-selected",
        calendarWidgetTimeSelector: "calendar-widget-time-selector",
        callerResponse: "caller-response",
        callerResponseText: "caller-response-text",
        callToAction: "alme--window--conversation--response--alme__message__callToAction",
        callToActionButton: "alme--window--conversation--response--alme__message__callToAction__button",
        callToActionButtonAgentAssist: "callToAction__button-agent-assist",
        callToActionButtonDisabled: "alme--window--conversation--response--alme__message__callToAction__button-disabled",
        callToActionButtonDisabledAgentAssist: "callToAction__button-disabled-agent-assist",
        callToActionWrapper: "alme--window--conversation--response--alme__message__callToAction-wrapper",
        closeClassName: "alme--window--header--toolbar--close",
        conversationAreaClassName: "alme--window--conversation",
        conversationAreaNewMessageButton: "alme--window--conversation--new--message--button",
        conversationAreaSpanner: "alme--window--conversation__spanner",
        dataCollectionArea: "alme--window--feedback__data-collection-area",
        dataCollectionButtonArea: "alme--window--feedback__data-collection__button-area",
        dataCollectionCancelButton: "alme--window--feedback__data-collection__cancel-button",
        dataCollectionCloseButton: "alme--window--feedback__data-collection__close-button",
        dataCollectionFeedbackPane: "alme--window--feedback__data-collection__pane",
        dataCollectionPaneComboBox: "alme--window--feedback__data-collection__combo-box",
        dataCollectionPaneComboLabel: "alme--window--feedback__data-collection__combo-label",
        dataCollectionPaneComboOption: "alme--window--feedback__data-collection__combo-option",
        dataCollectionPaneDataList: "alme--window--feedback__data-collection__data-list",
        dataCollectionPaneError: "alme--window--feedback__data-collection__error",
        dataCollectionPaneTextBox: "alme--window--feedback__data-collection__textbox",
        dataCollectionPaneTextBoxLabel: "alme--window--feedback__data-collection__textbox-label",
        dataCollectionSubmitButton: "alme--window--feedback__data-collection__submit-button",
        dataCollectionValidateRequiredSymbol: "alme--window--feedback__data-collection__require-symbol",
        dataCollectionValidateRequiredDesc: "alme--window--feedback__data-collection__validate-required",
        dataCollectionPaneCheckboxGroup: "alme--window--feedback__data-collection__checkbox-group",
        dataCollectionPaneCheckboxGroupLabel: "alme--window--feedback__data-collection__checkbox-group-label",
        dataCollectionPaneCheckboxGroupOptionContainer: "alme--window--feedback__data-collection__checkbox-group__option-container",
        dataCollectionPaneCheckboxGroupOption: "alme--window--feedback__data-collection__checkbox-group__option",
        dataCollectionPaneCheckboxGroupOptionLabel: "alme--window--feedback__data-collection__checkbox-group__option-label",
        displayInlineClassName: "alme--window--conversation--response--alme--inline",
        displayLink: "alme--window--conversation--response--alme__message__displayLinks__link",
        displayLinkDisabled: "alme--window--conversation--response--alme__message__displayLinks__link-disabled",
        displayLinksCollection: "alme--window--conversation--response--alme__message__displayLinks",
        displayLinksFoldCollapsed: "alme--window--conversation--response--alme__message__displayLinks__fold--colapsed",
        displayLinksFoldExpanded: "alme--window--conversation--response--alme__message__displayLinks__fold--expanded",
        displayLinksSection: "alme--window--conversation--response--alme__message__displayLinks__section",
        displayLinksSectionHeader: "alme--window--conversation--response--alme__message__displayLinks__sectionHeader",
        dragToolClassName: "alme--window--header--toolbar--drag",
        feedbackBody: "alme--window--feedback__body",
        feedbackHeader: "alme--window--feedback__header",
        feedbackOtherTextArea: "alme--window--feedback__radio__text-area",
        feedbackOverlay: "alme--window--feedback",
        feedbackPrompt: "alme--window--feedback__prompt",
        feedbackRadioOption: "alme--window--feedback__radio__option",
        feedbackTextArea: "alme--window--feedback__text__box-area",
        footerClassName: "alme--window--footer",
        footerLinks: "alme--window--footer__links",
        headerClassName: "alme--window--header",
        headerButtonDisabled: "alme--window--header--button-disabled",
        helpClassName: "alme--window--agent--help",
        inlineSurveyLinks: "alme--window--survey__links",
        inlineSurveyLinksDisabled: "alme--window--survey__links-disabled",
        inlineSurveyNoLink: "alme--window--survey__no__link",
        inlineSurveyNoLinkDisabled: "survey-no-link-disabled",
        inlineSurveyYesLink: "alme--window--survey__yes__link",
        inlineSurveyYesLinkDisabled: "survey-yes-link-disabled",
        inputboxClassName: "alme--window--footer--inputbox",
        inputboxCharacterCounter: "alme--window--footer--inputbox_characterCounter",
        inputboxDisabledClassName: "alme--window--footer--inputbox__textarea__disabled",
        inputboxError: "alme--window--footer--inputbox__error",
        inputboxErrorHidden: "alme--window--footer--inputbox__error__hidden",
        inputboxSubmitClassName: "alme--window--footer--inputbox__submit",
        inputboxTextAreaClassName: "alme--window--footer--inputbox__textarea",
        inputDisplayLink: "alme--window--conversation--response--alme__message__displayLinks__link__input",
        itemAccordionButtonSubtitleClassName: "accordion--button--subtitle",
        itemAccordionClassName: "accordion--main--view",
        itemAccordionPanelContainer: "accordion--panel--container",
        itemAccordionPanelLeftColumn: "accordion--panel--container--left--column",
        itemAccordionPanelRightColumn: "accordion--panel--container--right--column",
        itemAccordionPanelRow: "accordion--panel--container--row",
        itemButtonClassName: "accordion--button",
        itemContentPanelClosedClassName: "accordion--content--panel--closed",
        itemContentPanelOpenClassName: "accordion--content--panel--open",
        itemContentPanelTitleGridItemClassName: "accordion--content--panel--title--grid--item",
        itemContentPanelValueGridItemClassName: "accordion--content--panel--value--grid--item",
        itemDetailsLinkClassName: "accordion--panel--container--details-link",
        languageSelector: "alme--window--footer--language_selector",
        languageSelectorDiv: "alme--window--footer--language_selector--div",
        languageSelectorLabel: "alme--window--footer--language_selector--label",
        launchPoint: "alme--launchPointContainer--launchPoint",
        launchPointContainer: "alme--launchPointContainer",
        launchPointContainerTablet: "alme--launchPointContainer--tablet",
        launchPointIcon: "alme--launchPointContainer--launchPoint__icon",
        launchPointText: "alme--launchPointContainer--launchPoint__text",
        livechat: {
            chatBannerConnectContainer: 'alme--livechat--banner--connect--container',
            chatBannerConnectPrimary: 'alme--livechat--banner--connect--primary',
            chatBannerConnectSecondary: 'alme--livechat--banner--connect--secondary',
            chatBannerConnectAdditional: 'alme--livechat--banner--connect--additional',
            chatBannerConnectingAdditional: "alme--livechat--banner--connecting--additional",
            chatBannerConnectingContainer: "alme--livechat--banner--connecting--container",
            chatBannerConnectingPrimary: "alme--livechat--banner--connecting--primary",
            chatBannerConnectingSecondary: "alme--livechat--banner--connecting--secondary",
            chatBannerDisconnectAdditional: 'alme--livechat--banner--disconnect--additional',
            chatBannerDisconnectContainer: 'alme--livechat--banner--disconnect--container',
            chatBannerDisconnectingAdditional: "alme--livechat--banner--disconnecting--additional",
            chatBannerDisconnectingContainer: "alme--livechat--banner--disconnecting--container",
            chatBannerDisconnectingPrimary: "alme--livechat--banner--disconnecting--primary",
            chatBannerDisconnectingSecondary: "alme--livechat--banner--disconnecting--secondary",
            chatBannerDisconnectPrimary: 'alme--livechat--banner--disconnect--primary',
            chatBannerDisconnectSecondary: 'alme--livechat--banner--disconnect--secondary',
            chatBannerQueuedContainer: 'alme--livechat--banner--queued--container',
            endChatLink: 'alme--livechat--endchat',
            endChatLinkContainer: 'alme--livechat--endchatcontainer',
            endChatWarning: "alme--window--end-chat--warning",
            endChatWarningButtonWrap: "alme--window--end-chat--warning__button__wrap",
            endChatWarningNoButton: "alme--window--end-chat--warning__no__button",
            endChatWarningPad: "alme--window--end-chat--warning__pad",
            endChatWarningShadow: "alme--window--end-chat--warning__shadow",
            endChatWarningText: "alme--window--end-chat--warning__text",
            endChatWarningYesButton: "alme--window--end-chat--warning__yes__button",
            endLiveChatLink: "alme--livechat--endchatlink",
            headerBannerText: 'alme--livechat--window--header--banner',
            inputContainer: 'alme--livechat--conversation--input',
            inputDisplayName: 'alme--livechat--conversation--input--message__displayname',
            inputDisplayNameClassName: "alme--livechat--conversation--input--message__displayname",
            inputMessage: 'alme--livechat--conversation--input--message',
            inputMessageClassName: "alme--livechat--conversation--input--message",
            inputPersonaIcon: 'alme--livechat--conversation--input--personaicon',
            inputPersonaIconClassName: "alme--livechat--conversation--input--personaicon",
            inputText: 'alme--livechat--conversation--input--message__text',
            inputTextClassName: "alme--livechat--conversation--input--message__text",
            responseContainer: 'alme--livechat--conversation--response',
            responseDisplayName: 'alme--livechat--conversation--response--message__displayname',
            responseDisplayNameClassName: "alme--livechat--conversation--response--message__displayname",
            responseError: 'alme--livechat--response--error',
            responseInlineLink: "alme--livechat--conversation--response--message__link",
            responseMessage: 'alme--livechat--conversation--response--message',
            responseMessageClassName: "alme--livechat--conversation--response--message",
            responsePersonaIcon: 'alme--livechat--conversation--response--personaicon',
            responsePersonaIconClassName: "alme--livechat--conversation--response--personaicon",
            responseText: 'alme--livechat--conversation--response--message__text',
            responseTextClassName: "alme--livechat--conversation--response--message__text",
            timestampInputClassName: "alme--livechat--conversation--input--timestamp",
            timestampResponseClassName: "alme--livechat--conversation--response--timestamp",
            typingNotification: 'alme--livechat--typingnotification',
        },
        minimizeClassName: "alme--window--header--toolbar--minimize",
        navigationLink: "alme--window--conversation--response--alme__message__navigationlink",
        navigationLinkDisabled: "alme--window--conversation--response--alme__message__navigationlink-disabled",
        navLinkMainPage: "alme--window--conversation--response--alme__message__navigationlink",
        navLinkMainPageHidden: "alme--window--conversation--response--alme__message__navigationlink_hidden",
        navLinkPopover: "alme--window--conversation--response--alme__message__navLinkPopover",
        navLinkPopoverArrow: "alme--window--conversation--response--alme__message__navLinkPopover__arrow",
        navLinkPopoverHeader: "alme--window--conversation--response--alme__message__navLinkPopover__header",
        navLinkPopoverBody: "alme--window--conversation--response--alme__message__navLinkPopover__body",
        noFeedbackButton: "alme--window--feedback__yes-no__no-button",
        notificationClassName: "alme--window--conversation--notification",
        notificationMessageClassName: "alme--window--conversation--notification__message",
        okFeedbackButton: "alme--window--feedback__ok__button",
        okFeedbackButtonArea: "alme--window--feedback__ok__button-area",
        okFeedbackPane: "alme--window--feedback__ok__pane",
        radioOptionFeedbackButton: "alme--window--feedback__radio__button",
        radioOptionFeedbackButtonArea: "alme--window--feedback__radio__button-area",
        radioOptionsFeedbackPane: "alme--window--feedback__radio__pane",
        radioOptionsForm: "alme--window--feedback__radio__form",
        resizeToolClassName: "alme--window--resize",
        responseDropdown: "alme--window--conversation--response--alme__message__dropdown",
        responseDropdownButtonCancel: "alme--window--conversation--response--alme__message__dropdown_cancel_button",
        responseDropdownButtonSubmit: "alme--window--conversation--response--alme__message__dropdown_submit_button",
        responseDropdownDiv: "alme--window--conversation--response--alme__message__dropdown_div",
        responseDropdownDivSubmitted: "alme--window--conversation--response--alme__message__dropdown_div_submitted",
        responseDropdownLabel: "alme--window--conversation--response--alme__message__dropdown_label",
        responseSelectSubmitContainer: "alme--window--conversation--response--alme__message__dropdown_container",
        sessionEndNotification: "alme--window--conversation--notification__sessionEnd",
        skipToContentButton: "alme--window__skip__to__content__button",
        skipToContentLink: "alme--window__skip__to__content__link",
        skipToContentWrapper: "alme--window__skip__to__content__wrapper",
        soundClassName: "alme--window--sound",
        soundOffClassName: "alme--window--sound__off",
        soundOnClassName: "alme--window--sound__on",
        stepOutIcon: "alme--window--conversation--response--alme__message__stepoutlink",
        survey: "alme--window--survey",
        surveyBody: "alme--window-survey__body",
        surveyButtonWrap: "alme--window--survey__button__wrap",
        surveyCancelLink: "alme--window--survey__links__cancel",
        surveyCloseButton: "alme--window--survey__close__button",
        surveyCloseButtonWrap: "alme--window--survey__close__button__wrap",
        surveyDropdown: "alme--window--survey__dropdown",
        surveyDropdownOption: "alme--window--survey__dropdown__option",
        surveyFooterButtonWrap: "alme--window--survey__footer__button__wrap",
        surveyFreeformText: "alme--window--survey__freeform__text",
        surveyHeader: "alme--window--survey__header",
        surveyLinkDisabled: "survey-link-disabled",
        surveyPad: "alme--window--survey__pad",
        surveyQuestion: "alme--window--survey__question",
        surveyQuestionButtonWrap: "alme--window--survey__question__button__wrap",
        surveyQuestionNoButton: "alme--window--survey__question__no__button",
        surveyQuestionNoButtonDisabled: "alme--window--survey__question__no__button__disabled",
        surveyQuestionText: "alme--window--survey__question__text",
        surveyQuestionYesButton: "alme--window--survey__question__yes__button",
        surveyQuestionYesButtonDisabled: "alme--window--survey__question__yes__button__disabled",
        surveyRadioButton: "alme--window--survey__radio__button",
        surveyRadioButtons: "alme--window--survey__radio__buttons",
        surveyShadow: "alme--window--survey__shadow",
        surveySubmitLink: "alme--window--survey__links__submit",
        surveySubmitLinkDisabled: "alme--window--survey__links__submit__disabled",
        surveyTitle: "alme--window--survey__title",
        surveyWrap: "alme--window--survey__wrap",
        tabletClassName: "alme--window--tablet",
        textAreaFeedbackButton: "alme--window--feedback__text__button",
        textAreaFeedbackButtonArea: "alme--window--feedback__text__button-area",
        textAreaFeedbackPane: "alme--window--feedback__text__pane",
        textAreaCharacterCounter: "alme--window--feedback__text__characterCounter",
        timeoutWarning: "alme--window--timeout--warning",
        timeoutWarningButtonWrap: "alme--window--timeout--warning__button__wrap",
        timeoutWarningNoButton: "alme--window--timeout--warning__no__button",
        timeoutWarningPad: "alme--window--timeout--warning__pad",
        timeoutWarningShadow: "alme--window--timeout--warning__shadow",
        timeoutWarningText: "alme--window--timeout--warning__text",
        timeoutWarningYesButton: "alme--window--timeout--warning__yes__button",
        toolbarClassName: "alme--window--header--toolbar",
        transitionFeedbackPane: "alme--window--feedback__transition__pane",
        unitDisplayLink: "alme--window--conversation--response--alme__message__displayLinks__link__unit",
        urlDisplayLink: "alme--window--conversation--response--alme__message__displayLinks__link__url",
        userInputClassName: "alme--window--conversation--input--user",
        userInputDisplayNameClassName: "alme--window--conversation--input--user__message__displayname",
        userInputMessageClassName: "alme--window--conversation--input--user__message",
        userInputPersonaIconClassName: "alme--window--conversation--input--user__personaicon",
        userInputTextClassName: "alme--window--conversation--input--user__message__text",
        windowClassName: "alme--window",
        windowForm: {
            copyButton: "alme--window--form--field--copy--button",
            copyButtonSelect: "alme--window--form--field--copy--button--select",
            form: "alme--window--form",
            formBody: "alme--window--form--body",
            formClearFieldsButton: "alme--window--form--clear--button",
            formCounterLabel:"alme--window--form--field--label alme--window--form--counter--field--label",
            formField: "alme--window--form--field",
            formFieldAsteriskRequired: "alme--window--form--field--label--required--asterisk",
            formFieldContainer: "alme--window--form--field--container",
            formFieldInputContainer: "alme--window--form--field--input--container",
            formFieldLabel: "alme--window--form--field--label",
            formFieldLabelRequired: "alme--window--form--field--label--required",
            formFooter: "alme--window--form--footer",
            formFooterContainer: "alme--window--form--footer--container",
            formHeader: "alme--window--form--field--label--header",
            formAppEventButton: "alme--window--form--app--event--button",
            multilineTextField: "alme--window--form--field--multiline--text",
            multiSelectField: "alme--window--form--field--multi--select",
            multiSelectItem: "alme--window--form--field--multi--select--item",
            multiSelectList: "alme--window--form--field--multi--select--list",
            multiSelectListCollapsed: "alme--window--form--field--multi--select--list--collapsed",
            selectField: "alme--window--form--field--select",
            singleLineTextField: "alme--window--form--field--singleline--text",
            staticField: "alme--window--form--field--static",
            warningBodyText: "alme--window--form--warning--body--text",
            warningButtonContainer: "alme--window--form--warning--button--container",
            warningCancel: "alme--window--form--warning--cancel",
            warningContinue: "alme--window--form--warning--continue",
            warningDialog: "alme--window--form--warning--dialog",
            warningHeader: "alme--window--form--warning--header",
            warningShadow: "alme--window--form--warning--shadow",

        },
        windowPaneClassName: "alme--window--pane",
        windowPaneToggle: "alme--window--pane--toggle",
        yesFeedbackButton: "alme--window--feedback__yes-no__yes-button",
        yesNoFeedbackButtonArea: "alme--window--feedback__yes-no__button-area",
        yesNoFeedbackPane: "alme--window--feedback__yes-no__pane",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/class-names.ts